import { AxiosResponse } from "axios";
import SendEmailApi from "../api/sendEmailApi";

const endpoint = "sendAnyway"

const SendEmailService = {
  async sendEmail(taskId: number): Promise<AxiosResponse<string>> {
    return await SendEmailApi.get(`${endpoint}?taskId=${taskId}`)
  }
}

export default SendEmailService;